import { render, staticRenderFns } from "./ManageTypeWiseCategory.vue?vue&type=template&id=d508fb26"
import script from "./ManageTypeWiseCategory.vue?vue&type=script&lang=js"
export * from "./ManageTypeWiseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports